import { programs } from './programs'
import { parseQueryString, preProcessClub } from './utils'
import { fetchClubs } from './apiCalls'

const userInfoLoaded = (cardnumber, program) => ({
  type: 'USER_INFO_LOADED',
  cardnumber,
  program
});

export const clubsLoaded = clubs => ({
  type: 'CLUBS_LOADED',
  clubs
});

const throwError = () => ({
  type: 'THROW_ERROR',
  message: 'You need to enter your valid credentials in order to see clubs.'
});

export const updateDataStatus = status =>({
  type: 'DATA_STATUS',
  status
});

const loadClubs = (cardnumber, program, pin, lastName) => dispatch => {
  return fetchClubs(cardnumber, program, pin, lastName).then ( response => {
    // loads data only if authorized, otherwise the login screen will be displayed by not dispatching the DATA_LOAD action
    if(response.body.status === 0) {
      dispatch(updateDataStatus('loaded'));
      const data = response.body.data || [];
      const clubs = data
        .map( club => preProcessClub(club, program))
        .filter( club => programs[program].supportedCards.indexOf(club.cardType) !== -1)
        .sort( function (club1, club2) {
          return club2.currentPunches - club1.currentPunches
        })

      return dispatch(clubsLoaded(clubs));
    } else {
      dispatch(updateDataStatus('toAuthorize'));
      return dispatch(throwError());      
    }
  });
}

export const loadUserInfo = queryString => dispatch => {
  let { cardnumber, program } = parseQueryString(queryString);
  if(program === 'nocorewards') {
    program = 'noco';
  }
  if(!programs[program]) {
    console.log('program not supported.');
  } else if(!cardnumber) {
    console.info('if the cardnumber is not present, no clubs can be loaded');
  } else {
    document.body.classList.toggle(program, true);
    dispatch(userInfoLoaded(cardnumber, program));
    return dispatch(loadClubs(cardnumber, program));
  }
}

export const login = (pin, lastName) => (dispatch, getState) => {
  console.log('logging with ', pin, lastName);
  const { cardnumber, program } = getState();
  return dispatch(loadClubs(cardnumber, program, pin, lastName));
};


const selectedCardIndexUpdated = index => ({
  type: 'SELECTED_CARD_INDEX_UPDATED',
  index
})

export const showPrevCard = () => (dispatch, getState) => {
  console.log('showing previous card')
  const { selectedCardIndex } = getState()
  if(selectedCardIndex > 0) {
    dispatch(selectedCardIndexUpdated(selectedCardIndex-1))
  }
}

export const showNextCard = () => (dispatch, getState) => {
  console.log('showing next card')
  const { clubs, selectedCardIndex } = getState()
  if(selectedCardIndex < (clubs.length-1)) {
    dispatch(selectedCardIndexUpdated(selectedCardIndex+1))
  }
}




// WEBPACK FOOTER //
// ./src/store/actions.js